export const LETTER_SPACING = [
  { name: '-100', value: -100 },
  { name: '-75', value: -75 },
  { name: '-50', value: -50 },
  { name: '-25', value: -25 },
  { name: '-10', value: -10 },
  { name: '0', value: 0 },
  { name: '5', value: 5 },
  { name: '10', value: 10 },
  { name: '25', value: 25 },
  { name: '50', value: 50 },
  { name: '75', value: 75 },
  { name: '100', value: 100 },
  { name: '200', value: 200 }
];
